export { default } from "./string-details-field";
